const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  appName: "MOMS EDUC",
  subAppName: "STUDY",
  appDescription: "Votre partenaire pour les études à l'étranger",

  // ── Contact principal ──────────────────────────────────────────────────────
  contactEmail: "study@momseduc.com",
  privacyEmail: "study@momseduc.com",

  // ── Téléphones ─────────────────────────────────────────────────────────────
  phonesFrance: "+33 692 70 70 30",
  phonesCameroun: "+237 692 70 70 30",
  /** Numéro WhatsApp principal (format international sans +) */
  whatsappNumber: "33692707030",

  // ── Bureaux ────────────────────────────────────────────────────────────────
  offices: {
    france: {
      label: "Bureau France",
      street: "9 rue Louis Boulanger",
      city: "61300 L'Aigle",
      country: "France",
      /** Adresse complète sur une ligne */
      full: "9 rue Louis Boulanger, 61300 L'Aigle, France",
    },
    cameroun: {
      label: "Bureau Cameroun",
      street: "Face Neptune Tam-Tam",
      city: "Yaoundé",
      country: "Cameroun",
      full: "Face Neptune Tam-Tam, Yaoundé, Cameroun",
    },
  },

  // ── Réseaux sociaux ────────────────────────────────────────────────────────
  socialLinks: {
    facebook: "https://facebook.com/momseduc",
    instagram: "https://instagram.com/momseduc",
    whatsapp: "https://wa.me/+237692707030",
  },
};

export default config;
